import { render } from "./InventoryPorLPN.vue?vue&type=template&id=2c390517"
import script from "./InventoryPorLPN.vue?vue&type=script&lang=js"
export * from "./InventoryPorLPN.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__